/* eslint-disable max-len */
// Route Components
import {
  Login,
  LoginTwoFa,
  TrialSignup,
  TrialEmailConfirmation,
  VaspSignup,
  UserSignup,
  VaspEmailConfirmation,
  VaspUserEmailConfirmation,
  EmailVerification,
  ResetPassword,
  ResetPasswordConfirm,
  UpdatePassword,
  NotFound,
  UserDetails,
  Settings,
  BusinessDetails,
  Accounts,
  AccountDetails,
  Vasps,
  VaspDetails,
  TravelRule,
  Address,
  Transactions,
  // AI Assistant
  AICatalyst,
  // Investigation,
  ReportsAddress,
  ReportsTransaction,
  ReportsTravelRule,
  // Admin
  AdminVasps,
  AdminVaspDetails,
  AdminRequestedVasps,
  AdminCustomerVasps,
  AdminMidProspectVasps,
  // Ai
  AiDocument,
  AiDocumentDetails,
} from 'views/pages'

export default [
  // Home
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: TravelRule,
      path: '/travelrule',
    },
  },

  // Directory
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: Accounts,
      path: '/directory',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: Vasps,
      path: '/directory/vasps',
    },
  },
  // Directory Details
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: AccountDetails,
      path: '/directory/accounts/details/:account_id',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: VaspDetails,
      path: '/directory/vasps/details/:vasp_id',
    },
  },

  // Blockchain Analytics
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: Address,
      path: '/blockchain-analytics',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: Transactions,
      path: '/blockchain-analytics/transactions',
    },
  },
  // Reports
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: ReportsAddress,
      path: '/reports',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: ReportsTransaction,
      path: '/reports/transaction',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: ReportsTravelRule,
      path: '/reports/travelrule',
    },
  },
  // User Profile
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: UserDetails,
      path: '/user-details/:user_id',
    },
  },
  // Settings
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: Settings,
      path: '/settings',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: BusinessDetails,
      path: '/business-details',
    },
  },
  // Ai Chat
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: false,
    isRoutePublic: false,
    routing: {
      component: AICatalyst,
      path: '/ai-catalyst/:preprompt',
    },
  },

  // ----- ADMIN ROUTES -----
  // Vasp Notification
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: AdminVasps,
      path: '/admin/vasps',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: AdminRequestedVasps,
      path: '/admin/vasps/requested',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: AdminCustomerVasps,
      path: '/admin/vasps/customers',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: AdminMidProspectVasps,
      path: '/admin/vasps/midprospects',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: AdminVaspDetails,
      path: '/admin/vasps/details/:vasp_id',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'local') ? AiDocument : NotFound,
      path: '/admin/ai/documents',
    },
  },
  {
    exact: true,
    isRouteProtected: true,
    isRouteAdmin: true,
    isRoutePublic: false,
    routing: {
      component: (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'local') ? AiDocumentDetails : NotFound,
      path: '/admin/ai/documents/:document_id',
    },
  },

  // ----- PUBLIC ROUTES -----
  // Trial Signup
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: process.env.REACT_APP_ENV !== 'prod' ? TrialSignup : NotFound, path: '/signup/trial' },
  },
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: {
      component: process.env.REACT_APP_ENV !== 'prod' ? TrialEmailConfirmation : NotFound,
      path: '/signup/trial/confirmation/:hash',
    },
  },
  // Vasp Signup
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: VaspSignup, path: '/register/:token' },
  },
  // Vasp Email Confirmation
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: VaspEmailConfirmation, path: '/confirm_email/:hash' },
  },
  // Vasp User Email Confirmation
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: VaspUserEmailConfirmation, path: '/confirm_vasp_user/:hash' },
  },
  // Login
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: Login, path: '/login' },
  },
  // Email Verification
  {
    isRouteAdmin: false,
    isRouteProtected: false,
    isRoutePublic: true,
    exact: true,
    routing: { component: EmailVerification, path: '/email/confirm/:auth_hash' },
  },
  // LoginTwoFa
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: LoginTwoFa, path: '/login/:auth_hash' },
  },
  // User Activation
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: UserSignup, path: '/user/activation/:auth_hash' },
  },
  // Update Password
  {
    isRouteAdmin: false,
    isRoutePublic: false,
    isRouteProtected: true,
    exact: true,
    routing: { component: UpdatePassword, path: '/update_password' },
  },
  // Reset Password
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: ResetPasswordConfirm, path: '/reset_password/:auth_hash' },
  },
  {
    isRouteAdmin: false,
    isRoutePublic: true,
    isRouteProtected: false,
    exact: true,
    routing: { component: ResetPassword, path: '/reset_password' },
  },
  {
    isRouteAdmin: false,
    isRoutePublic: false,
    isRouteProtected: false,
    exact: false,
    routing: { component: NotFound },
  },
]
